import React, { Component } from 'react';
import FormError from '../../models/FormError';

type InputFieldProps = {
    errors: FormError[],
    name?: string
}

export default class ErrorFieldMessage extends Component<InputFieldProps> {

    public render() {
        return <React.Fragment>
            {
                this.props.errors.length > 0 ?
                    <div id={"err_" + this.props.name}
                        role="alert"
                        aria-live="assertive"
                        aria-describedby={this.props.name + "Error"}
                    >
                        {this.props.errors.filter(err => { return !this.props.name || err.field === this.props.name }).map((errors, mainIndex: number) => {
                            return (
                                <React.Fragment key={mainIndex}>
                                    {errors.errors.map((message: string, index: number) => {
                                        return (<span className="text-red text-small" key={this.props.name + message + index}>{message}<br /></span>);
                                    })}
                                </React.Fragment>);
                        })}
                    </div>
                    : null
            }
        </React.Fragment>
    }
}